
import { supabase } from "../../supabaseClient";

const TABLE_NAME = 'draft_history';

// Save or update a draft (upsert)
export async function saveDraft(key, value) {
  const { error } = await supabase
    .from(TABLE_NAME)
    .upsert([{ key, value }], { onConflict: 'key' }); // Add this option
  if (error) console.error('Draft save error:', error);
  return error;
}

// Fetch a draft by key
export async function getDraft(key) {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('value')
    .eq('key', key)
    .maybeSingle(); // Use maybeSingle() to handle 0 or 1 results without error
  if (error) {
    console.error('Draft fetch error:', error);
    return null;
  }
  return data?.value || '';
}

// Delete a draft by key
export async function deleteDraft(key) {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('key', key);
  return error;
}

